module.exports = __webpack_public_path__ + "static/media/feature-mass1.f37e81a3.png";